import React, { useEffect, useState , useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Modal from "../../shared/Modal";
import {
  fetchAppointments,
  deleteAppointment,
  selectAppointments,
  selectAppointmentsLoading,
} from '../../../ReduxSlices/Appointments/appointmentsSlice';


const mapAppointmentsToEvents = (appointments) =>
  appointments.map((appt) => {
    const start = new Date(appt.scheduled_at);
    const end = new Date(start.getTime() + 60 * 60 * 1000);

    return {
      id: appt.id,
      title: `${appt.patient?.name || "Unknown"} - ${appt.notes || ""}`,
      start,
      end,
      allDay: false,
      extendedProps: {
        doctor: appt.doctor?.name || "N/A",
        doctor_id: appt.doctor_id,
        patient_id: appt.patient?.id || null,
        notes: appt.notes || "",
        status: appt.status,
        scheduled_at: appt.scheduled_at,
      },
    };
  });

const KalendaApp = ({ navigateTo }) => {
  const dispatch = useDispatch();
  const appointments = useSelector(selectAppointments);
  const loading = useSelector(selectAppointmentsLoading);

    useEffect(() => {
      if( appointments.length === 0){
          dispatch(fetchAppointments());
        }
      }, [dispatch, appointments.length]);

  const [selectedEvent, setSelectedEvent] = useState(null);
  const calendarRef = useRef(null);

   
  // Map Redux data into calendar events
  const events = mapAppointmentsToEvents(appointments);

  return (
    <>
      <FullCalendar
        ref={calendarRef}
        plugins={[dayGridPlugin, timeGridPlugin,
           interactionPlugin
        ]}
        initialView="dayGridMonth"
        scrollTime="08:00:00"
        slotMinTime="08:00:00"
        slotMaxTime="20:00:00"
        slotDuration="00:30:00"  
        allDaySlot={false}
        expandRows={true}
        height="auto"     
        headerToolbar={{
          left: "prev,next today",
          center: "title",
           right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        events={events}
        eventTimeFormat={{
          hour: "2-digit",
          minute: "2-digit",
          meridiem: true
        }}
        eventClick={(info) => setSelectedEvent(info.event)}
        dateClick={(info) => {
        const calendarApi = calendarRef.current?.getApi();
        calendarApi.changeView('timeGridDay', info.date); 
      }}
      />

      <Modal isOpen={!!selectedEvent} onClose={() => setSelectedEvent(null)}>
        {selectedEvent && (
          <div className="modal-inner">
            <h2>{selectedEvent.title}</h2>
            <p>
              <strong>Doctor:</strong> {selectedEvent.extendedProps.doctor}
            </p>
            <p>
              <strong>Status:</strong> {selectedEvent.extendedProps.status}
            </p>
            <p>
              <strong>Time:</strong>{" "}
              {selectedEvent.start.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}{" "}
              -{" "}
              {selectedEvent.end.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}
            </p>

            <div className="flex justify-between mt-3">
              <button
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                onClick={async () => {
                  const confirmDelete = window.confirm(
                    "Are you sure you want to delete this appointment?"
                  );
                  if (!confirmDelete) return;

                  try {
                    await dispatch(deleteAppointment(selectedEvent.id));

                    // Remove from calendar
                    const calendarApi = calendarRef.current?.getApi();
                    calendarApi?.getEventById(selectedEvent.id)?.remove();

                    setSelectedEvent(null);
                  } catch (err) {
                    console.error("❌ Failed to delete:", err);
                  }
                }}
              >
                Delete
              </button>

              <button
                className="primary"
                onClick={() => {
                  const data = {
                    id: selectedEvent.id,
                    patient_id: selectedEvent.extendedProps.patient_id,
                    doctor_id: selectedEvent.extendedProps.doctor_id,
                    scheduled_at:
                      selectedEvent.extendedProps.scheduled_at.slice(0, 16),
                    notes: selectedEvent.extendedProps.notes,
                    status: selectedEvent.extendedProps.status,
                  };

                  if (typeof navigateTo === "function") {
                    navigateTo("book_appointment", { initialData: data });
                  }
                  setSelectedEvent(null);
                }}
              >
                Update
              </button>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default KalendaApp;